import { render, staticRenderFns } from "./CopyPaste.vue?vue&type=template&id=114cdbec&scoped=true"
import script from "./CopyPaste.vue?vue&type=script&lang=js"
export * from "./CopyPaste.vue?vue&type=script&lang=js"
import style0 from "./CopyPaste.vue?vue&type=style&index=0&id=114cdbec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114cdbec",
  null
  
)

export default component.exports